import { Directive, ElementRef, Injector, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DirectiveSuperclass } from '@sama/ng-core';
import { EventTrackingService } from '../event-tracking.service';
import { ScrollEventsListener } from './scroll-events-listener';

@Directive({
  selector: '[h3TrackScrollEvents]',
  standalone: false,
})
export class TrackScrollEventsDirective
  extends DirectiveSuperclass
  implements OnInit
{
  @Input({ required: true }) h3TrackScrollEvents!: string;

  constructor(
    private dialog: MatDialog,
    private el: ElementRef,
    private eventTrackingService: EventTrackingService,
    injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit() {
    const target: HTMLElement = this.el.nativeElement;
    new ScrollEventsListener(
      target,
      this,
      this.eventTrackingService,
      'shape_list',
      this.dialog,
    ).startListening(() => [target.scrollLeft, target.scrollTop], {
      source: this.h3TrackScrollEvents,
    });
  }
}
